import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const CSS_Comments = () => {
  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">💬 CSS Comments</h1>

      <p className="tutorial-intro">
        Comments in CSS are used to explain code, make it more readable, or
        temporarily disable styles. Browsers completely ignore comments, so they
        don’t affect how the page looks.
      </p>

      {/* Basic Syntax */}
      <div className="tutorial-section">
        <h2 className="section-title">📘 Syntax of Comments</h2>
        <p>
          A CSS comment starts with <code>/*</code> and ends with{" "}
          <code>*/</code>.
        </p>
        <CodeCopyBlock
          code={`/* This is a single-line comment */

p {
  color: green; /* This comment is written beside code */
}

/*
 This is a multi-line comment
 It can span across several lines
*/
`}
        />
      </div>

      {/* Why Use Comments */}
      <div
        style={{
          background: "linear-gradient(135deg, #fef9c3, #fde68a)",
          padding: "1rem",
          borderRadius: "12px",
          marginBottom: "2rem",
        }}
      >
        <h2 style={{ color: "#854d0e", marginBottom: "0.5rem" }}>
          ✨ Why Use Comments?
        </h2>
        <ul style={{ lineHeight: "1.8", paddingLeft: "1.5rem" }}>
          <li>To describe sections of your stylesheet.</li>
          <li>To make code easier to understand for yourself or others.</li>
          <li>To temporarily disable a line of CSS without deleting it.</li>
        </ul>
      </div>

      {/* Example: Temporary Disable */}
      <div className="tutorial-section">
        <h2 className="section-title">🛠️ Example: Temporarily Disable Code</h2>
        <p>
          You can comment out a CSS rule to test how your page looks without it.
        </p>
        <CodeCopyBlock
          code={`h1 {
  color: red;
  font-size: 24px;
}

/* h1 {
  color: blue;
  font-size: 30px;
} */
`}
        />

        <div
          style={{
            border: "1px solid #ddd",
            padding: "1rem",
            borderRadius: "8px",
            marginTop: "1rem",
            textAlign: "center",
          }}
        >
          <h1 style={{ color: "red", fontSize: "24px", margin: 0 }}>
            This heading uses active CSS
          </h1>
          <p style={{ fontSize: "14px", color: "#555" }}>
            The blue version is commented out and ignored by the browser.
          </p>
        </div>
      </div>

      {/* Notes */}
      <div className="tutorial-section">
        <h2 className="section-title">⚠️ Important Notes</h2>
        <ul className="tutorial-list">
          <li>
            Comments cannot be nested. Writing <code>/* ... /* ... */</code>{" "}
            will break the CSS.
          </li>
          <li>
            Use meaningful comments — avoid cluttering your CSS with too many
            notes.
          </li>
        </ul>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          Now that you know how to use comments, continue with{" "}
          <a href="/css/colors" className="learn-more">
            CSS Colors
          </a>{" "}
          to learn how to style elements with different color formats.
        </p>
      </div>
    </div>
  );
};

export default CSS_Comments;
